module.exports = __webpack_public_path__ + "static/media/toyota.be040727.jpg";